import axios from 'axios';
import environment from 'environment';

import { JsonResponse, Pagination } from 'core/models/response';
import { Country } from '../models/countries';

interface GetCountriesResponse {
	countries: Country[];
	pagination: Pagination;
}

export const onGetAllCountries = () => {
	return axios.get<JsonResponse<GetCountriesResponse>>(`${environment.BASE_API_ENDPOINT}/global/countries`);
};

export const onGetCountries = (page: number = 1) => {
	return axios.get<JsonResponse<GetCountriesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/countries`, {
		params: {
			page,
		},
	});
};

export const onGetCountry = (countryId: string) => {
	return axios.get<JsonResponse<Country>>(`${environment.BASE_API_ENDPOINT}/admin/countries/${countryId}`);
};

export const onCreateCountry = (countryData: FormData) => {
	return axios.post<JsonResponse<GetCountriesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/countries`, countryData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const onUpdateCountry = (countryId: string, countryData: FormData) => {
	return axios.post<JsonResponse<Country>>(`${environment.BASE_API_ENDPOINT}/admin/countries/${countryId}`, countryData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const onDeleteCountry = (countryId: number) => {
	return axios.delete(`${environment.BASE_API_ENDPOINT}/admin/countries/${countryId}`);
};
